import { html, TemplateResult } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './pc-form.lightDom.css.lit';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

/**
 * The Form component.
 * @element pc-form
 * @slot - default slot
 */
@customElement('pc-form')
export class PCForm extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: String, reflect: true, attribute: 'form-type' })
  formType: 'search';

  @property({ type: Boolean, reflect: true, attribute: 'hide-labels' })
  hideLabels: boolean;

  connectedCallback(): void {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-form': PCForm;
  }
}
